import star from '~/assets/icons/four_final_star.svg';
import helpFaq from '~/assets/icons/help_faq.svg';
import logo from '~/assets/icons/logo.png';
// import settings from '~/assets/icons/settings.svg';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import {
	setReportVisible,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { MenuTabs } from '../MenuTabs';
import {
	StyledButtonContent,
	StyledButtonsContainer,
	StyledContainer,
	StyledLogoContainer,
	StyledPhotoShine,
	StyledRightContainer,
	StyledUserImage,
	StyledUserImageContainer,
	StyledUserInfoContainer,
	StyledWrapper,
	StyledXPContainer,
} from './HeadMenu.styled';

const HeadMenu = () => {
	const dispatch = useLayoutDispatch();
	const playerLevel = useObservable(rage.player.getPlayerLevel());
	const nickname = useObservable(rage.player.getNickname());
	const exp = playerLevel?.exp ?? 0;
	const nextLevelExp = playerLevel?.nextLevelExp ?? 0;
	const level = playerLevel?.level ?? 0;
	const reportVisible = useLayoutSelector(
		(state) => state.mainMenu.reportVisible,
	);

	return (
		<StyledWrapper>
			<StyledContainer>
				<StyledLogoContainer>
					<img src={logo} />
				</StyledLogoContainer>
				<MenuTabs />
				<StyledButtonsContainer>
					{/* <Button
					color={ButtonColors.Default}
					height={ButtonHeight.Height40}
					style={{ borderRadius: 5 }}
				>
					<StyledButtonContent>
						<img src={settings} />
						<Text>Настройки</Text>
					</StyledButtonContent>
				</Button> */}
					<Button
						color={reportVisible ? ButtonColors.Cancel : ButtonColors.Default}
						height={ButtonHeight.Height40}
						style={{ borderRadius: 5 }}
						onClick={() => dispatch(setReportVisible(true))}
					>
						<StyledButtonContent>
							<img src={helpFaq} />
							<Text>Обращения</Text>
						</StyledButtonContent>
					</Button>
				</StyledButtonsContainer>
				<Divider
					$direction="V"
					style={{ opacity: 0.1, height: 40, margin: '0 40px' }}
				/>
				<StyledRightContainer>
					<StyledXPContainer>
						<img src={star} width={16} height={16} />
						<Divider
							$direction="V"
							$color="#000000"
							style={{ opacity: 0.1, height: 16 }}
						/>
						<Text>
							<span style={{ fontWeight: 700, fontSize: 16 }}>
								{exp.toLocaleString('ru-RU')}
							</span>
							<span style={{ fontWeight: 400, fontSize: 14, opacity: 0.5 }}>
								&nbsp;/ {nextLevelExp.toLocaleString('ru-RU')}
							</span>
						</Text>
					</StyledXPContainer>
					<StyledUserInfoContainer>
						<Text
							style={{
								fontWeight: 500,
								fontSize: 16,
								color: '#ffffff',
								whiteSpace: 'nowrap',
							}}
						>
							{nickname}
						</Text>
						<Divider $direction="V" style={{ opacity: 0.05, height: 28 }} />
						<Text
							style={{ fontSize: 16, color: '#ffffff', whiteSpace: 'nowrap' }}
						>
							<span style={{ fontWeight: 500 }}>{level}</span>{' '}
							<span style={{ fontWeight: 400, opacity: 0.5 }}>ур.</span>
						</Text>
					</StyledUserInfoContainer>
					<StyledUserImageContainer>
						<StyledPhotoShine
							className="top"
							style={{ backgroundColor: '#52A3D0' }}
						/>
						<StyledPhotoShine
							className="bottom"
							style={{ backgroundColor: '#FACDE1' }}
						/>
						<StyledUserImage />
					</StyledUserImageContainer>
				</StyledRightContainer>
			</StyledContainer>
		</StyledWrapper>
	);
};

export { HeadMenu };
